import React from "react";
import useFrontPageCta from "../../../Hooks/useFrontPageCta";

// Components
import ButtonPillGradient from "../../Buttons/ButtonPillGradient";

// Constants
import { RoutePaths } from "../../../Constants/RoutePaths";

// Helpers
import { formatMoney } from "../../../Helpers/Currency/Currency";
import { withPromotionCode } from "../../../Helpers/PromotionCode";
import {
    getMonthlyRenewalCopy,
    resolveMarketingPlanPricing,
    selectMonthlyMarketingPlan,
} from "../../../Helpers/PlanPricing";

// Models
import PlanDTO from "../../../Models/DTOs/Plan";

interface FrontFinalCtaProps {
    plans: PlanDTO[] | null;
}

const FrontFinalCta: React.FC<FrontFinalCtaProps> = ({ plans }) => {
    const monthlyPlan = selectMonthlyMarketingPlan(plans);
    const pricing = resolveMarketingPlanPricing(monthlyPlan);
    const initialPrice = pricing
        ? formatMoney(pricing.initialPrice, pricing.currency)
        : null;
    const renewalPrice = pricing
        ? formatMoney(pricing.renewalPrice, pricing.currency)
        : null;
    const actionText = initialPrice
        ? `Start watching for ${initialPrice}`
        : "Start watching";
    const cta = useFrontPageCta(actionText, withPromotionCode(RoutePaths.SignUp[0]));
    const renewalText = getMonthlyRenewalCopy(
        pricing,
        initialPrice,
        renewalPrice
    );

    return (
        <section
            className="front-final-cta"
            aria-labelledby="front-final-cta-heading"
        >
            <div className="front-final-cta__background" aria-hidden="true" />
            <div className="front-final-cta__inner">
                <p className="front-final-cta__kicker">
                    More than something to watch
                </p>
                <h2 id="front-final-cta-heading">
                    Come for the stories. Stay for the conversation.
                </h2>
                <p className="front-final-cta__copy">
                    Join for independent films, current affairs and a
                    community-focused experience where curious people ask,
                    listen and decide for themselves.
                </p>
                <ButtonPillGradient
                    text={cta.text}
                    link={cta.link}
                    className="front-final-cta__action"
                    background="linear-gradient(225deg, rgba(187, 54, 184, 1) 0%, #b760b4 100%)"
                    backgroundHover="#b760b4"
                    color="white"
                />
                {renewalText ? (
                    <p className="front-final-cta__renewal">{renewalText}</p>
                ) : null}
            </div>
        </section>
    );
};

export default FrontFinalCta;
